export enum ReportDataType {
  RETURNED_LINE_ITEMS = "returned_products",
  RETURNS = "returns",
  ORDERED_LINE_ITEMS = "ordered_products",
  WARRANTY_CUSTOMERS = "warranty_customers",
  PURCHASED_EXTENDED_WARRANTY = "purchased_extended_warranty",
  BILLING_CHARGES = "billing_charges",
}
